// ===== SIDEBAR GROUPS =====
// ===== Modo simulação / homologação (dados fictícios) =====
// Ativação: ?simulacao=1 na URL ou localStorage.modo_simulacao='1'.
window.SIMULACAO=/[?&]simulacao=1/.test(location.search)||localStorage.getItem('modo_simulacao')==='1';
if(window.SIMULACAO){
  document.addEventListener('DOMContentLoaded',()=>{
    const b=document.createElement('div');
    b.id='banner-simulacao';
    b.textContent='VERSÃO DE TESTES — DADOS FICTÍCIOS E NÃO PRODUTIVOS';
    b.style.cssText='position:fixed;top:0;left:0;right:0;z-index:99999;background:#b45309;color:#fff;text-align:center;font:700 12px/26px system-ui;letter-spacing:.08em;height:26px;-webkit-text-fill-color:#fff';
    document.body.appendChild(b);
    document.body.style.paddingTop='26px';
  });
}
// A versão/release não fica mais dentro da sidebar (ocupava espaço no modo
// recolhido, feedback do usuário) — mora no menu de perfil, junto de "Sair".
function montarRailNavegacao(){
  const stamp=document.getElementById('build-stamp');
  if(!stamp)return;
  stamp.textContent=APP_RELEASE?formatarIdentificacaoRelease(APP_RELEASE):'carregando release...';
  APP_RELEASE_READY.then(release=>{if(release&&stamp.isConnected)stamp.textContent=formatarIdentificacaoRelease(release)});
}
function destacarGrupoRail(grp){
  document.querySelectorAll('#sidebar .sb-group-hdr').forEach(el=>{
    el.classList.toggle('active',el.dataset.grp===grp);
  });
}
// Único grupo aberto por vez, sempre em accordion inline. Se a sidebar
// estava recolhida, abrirSidebarAoInteragir() já a reabriu antes disto rodar.
function selecionarGrupoRail(grp){
  abrirSidebarAoInteragir();
  destacarGrupoRail(grp);
  document.querySelectorAll('#sidebar .sb-group-items').forEach(el=>{
    const on=el.dataset.grp===grp;
    const hdr=el.previousElementSibling?.classList?.contains('sb-group-hdr')?el.previousElementSibling:null;
    el.classList.toggle('sb-grp-collapsed',!on);
    hdr?.classList.toggle('sb-grp-collapsed',!on);
  });
  try{localStorage.setItem('sb_rail_grp',grp)}catch(e){}
  saveSbGroups();
}
function toggleAlertasDrawer(){
  const d=document.getElementById('alertas-drawer');if(!d)return;
  d.classList.toggle('open');
  if(d.classList.contains('open'))renderAlertasDrawer();
}
function abrirPaginaAlerta(pg){
  showPage(pg);
  toggleAlertasDrawer();
}
function abrirPagina(pg){
  showPage(pg);
}
function renderAlertasDrawer(){
  const corpo=document.getElementById('alertas-drawer-corpo');if(!corpo)return;
  const r=resumoAlertasOperacionais();
  const linha=(rot,n,pg,cor)=>n?`<div style="display:flex;justify-content:space-between;align-items:center;border:1px solid var(--border);border-radius:9px;padding:8px 11px;margin-bottom:7px;cursor:pointer" onclick="abrirPaginaAlerta('${pg}')"><span style="font-size:12.5px">${rot}</span><strong style="color:${cor||'var(--red)'}">${n}</strong></div>`:'';
  const alertas=linha('⚠ Follow-ups de leads atrasados',r.followups,'leads')+linha('💰 Recebíveis vencidos',r.recebiveis,'recebiveis')+linha('⚖️ Prazos jurídicos (7 dias)',r.juridico,'juridico')+linha('🔧 Manutenções (7 dias)',r.manutencoes,'manutencao')+linha('✅ Tarefas vencidas',r.tarefas,'tarefas','#f59e0b');
  const limpo=window._atividadeRecenteLimpaEm;
  const ult=auditoriaSemRepeticoesTecnicas(CACHE.auditoria||[]).filter(a=>!limpo||String(a.timestamp||a.data||'')>limpo).slice(0,8);
  corpo.innerHTML=`<div style="font-size:11px;font-weight:800;color:var(--muted);letter-spacing:.06em;margin-bottom:7px">ALERTAS</div>
    ${alertas||'<div style="font-size:12.5px;color:var(--green);margin-bottom:8px">✔ Sem alertas críticos</div>'}
    <div style="font-size:11px;font-weight:800;color:var(--muted);letter-spacing:.06em;margin:14px 0 7px">ATIVIDADE RECENTE</div>
    ${ult.length?ult.map(a=>`<div style="font-size:11.5px;padding:5px 0;border-bottom:1px solid var(--border)"><strong>${escapeHtml(a.usuario||'')}</strong> — ${escapeHtml(String(a.descricao||'').slice(0,90))}<div style="color:var(--muted);font-size:10px">${typeof fmtTs==='function'?fmtTs(a.timestamp):''}</div></div>`).join(''):'<div style="font-size:12px;color:var(--muted)">Sem registros recentes.</div>'}
    <button class="btn btn-ghost btn-sm" style="margin-top:10px;width:100%" onclick="showPage('historico');toggleAlertasDrawer()">Ver histórico completo →</button>`;
  const tot=r.followups+r.recebiveis+r.juridico+r.manutencoes+r.tarefas;
  atualizarBadgesAlertas(tot);
}
function atualizarBadgesAlertas(tot){
  window._alertasTotalAtual=tot;
  const visto=Number(localStorage.getItem('alertasVistoTotal')||0);
  const mostrar=Math.max(0,tot-visto);
  ['alertas-tab-n','alertas-top-n'].forEach(id=>{
    const n=document.getElementById(id);if(n){n.textContent=mostrar;n.style.display=mostrar?'flex':'none';}
  });
}
function marcarAlertasVisualizados(){
  localStorage.setItem('alertasVistoTotal',String(window._alertasTotalAtual||0));
  atualizarBadgesAlertas(window._alertasTotalAtual||0);
  toast('Alertas marcados como visualizados ✓');
}
function limparAtividadeRecenteDrawer(){
  window._atividadeRecenteLimpaEm=new Date().toISOString();
  renderAlertasDrawer();
  toast('Atividade recente limpa. Os alertas pendentes continuam listados até serem resolvidos.');
}
function toggleSbGroup(hdr){
  abrirSidebarAoInteragir();
  hdr.classList.toggle('sb-grp-collapsed');
  const items=hdr.nextElementSibling;
  if(items) items.classList.toggle('sb-grp-collapsed');
  saveSbGroups();
}
// Sub-grupo recolhível dentro de um grupo (ex.: "Relatórios" dentro de
// Gestão, "Configurações" no rodapé). Se a sidebar estava recolhida (72px),
// abrirSidebarAoInteragir() já a reabriu antes de expandir o subgrupo em
// linha — sem flyout. Estado não persiste entre recarregamentos de
// propósito — começa sempre recolhido, para manter a lista curta.
function toggleSbSubgroup(hdr){
  abrirSidebarAoInteragir();
  hdr.classList.toggle('sb-grp-collapsed');
  hdr.setAttribute('aria-expanded',String(!hdr.classList.contains('sb-grp-collapsed')));
  const items=hdr.nextElementSibling;
  if(items)items.classList.toggle('sb-grp-collapsed');
}
function sincronizarAriaExpandedGrupos(){
  document.querySelectorAll('#sidebar .sb-group-hdr').forEach(h=>h.setAttribute('aria-expanded',String(!h.classList.contains('sb-grp-collapsed'))));
}
function saveSbGroups(){
  const state={};
  document.querySelectorAll('.sb-group-hdr').forEach(h=>{state[h.dataset.grp]=h.classList.contains('sb-grp-collapsed')});
  localStorage.setItem('sb_groups',JSON.stringify(state));
  sincronizarAriaExpandedGrupos();
}
function restoreSbGroups(){
  const state=JSON.parse(localStorage.getItem('sb_groups')||'{}');
  document.querySelectorAll('.sb-group-hdr').forEach(h=>{
    const grp=h.dataset.grp;
    if(grp in state){
      if(state[grp]){h.classList.add('sb-grp-collapsed');h.nextElementSibling?.classList.add('sb-grp-collapsed');}
      else{h.classList.remove('sb-grp-collapsed');h.nextElementSibling?.classList.remove('sb-grp-collapsed');}
    }
  });
  sincronizarAriaExpandedGrupos();
}
function expandSbGroupFor(page){
  const btn=document.querySelector(`.sb-item[onclick*="'${page}'"]`);
  if(!btn) return;
  const subItems=btn.closest('.sb-subgroup-items');
  if(subItems?.classList.contains('sb-grp-collapsed')){
    const subHdr=subItems.previousElementSibling;
    subHdr?.classList.remove('sb-grp-collapsed');
    subHdr?.setAttribute('aria-expanded','true');
    subItems.classList.remove('sb-grp-collapsed');
  }
  const items=btn.closest('.sb-group-items');
  if(items?.classList.contains('sb-grp-collapsed')){
    const hdr=items.previousElementSibling;
    hdr?.classList.remove('sb-grp-collapsed');
    items.classList.remove('sb-grp-collapsed');
    saveSbGroups();
  }
}
function syncRailForPage(page){
  const btn=document.querySelector(`.sb-item[onclick*="'${page}'"]`),grp=btn?.closest('.sb-group-items')?.dataset.grp||({pedidos:'operacao',config:'config'}[page]);
  if(grp)destacarGrupoRail(grp);
}

const TENANT_USAGE_PAGE_MODULE={dashboard:'overview',agenda:'overview',inteligencia:'overview',leads:'crm',clientes:'crm','pos-venda':'crm',orcamentos:'quotes',pedidos:'quotes',contratos:'contracts',juridico:'contracts',medicao:'measurement',projetos:'measurement',producao:'production','custos-producao':'production',manutencao:'production',os:'service_orders',operacional:'service_orders',caixa:'finance',recebiveis:'finance',pagamentos:'finance',extrato:'finance',integracoes:'finance',fiscal:'finance',dre:'finance',fluxo:'finance',pessoas:'people',usuarios:'people',rotinas:'people',documentos:'documents',config:'settings','uso-plano':'settings'};
function registrarUsoTenant(page){const org=window.MarmoriaSaaS?.state.organizationId,module=TENANT_USAGE_PAGE_MODULE[page];if(!org||!module||!firebase.auth?.().currentUser)return;const date=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Sao_Paulo',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()),key=`gaturamo_usage_${org}_${date}_${module}`;if(sessionStorage.getItem(key))return;sessionStorage.setItem(key,'pending');_callMarmorariaFunction('recordTenantUsage',{organizationId:org,module}).then(()=>sessionStorage.setItem(key,'done')).catch(e=>{sessionStorage.removeItem(key);console.warn('Telemetria mínima',e?.message||e)})}

